import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { VModal, VButton } from "@/components";
import { ref, computed } from "vue";
import i18n from "@/plugins/vue-i18n";
import { TranslateResult } from "vue-i18n";

interface Props {
  title?: string | TranslateResult;
  actionButtonText: string | TranslateResult;
  closeButtonText: string | TranslateResult;
  withDeclinedEvent: boolean;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'VModalConfirm',
  props: {
    title: { default: "" },
    actionButtonText: { default: "" },
    closeButtonText: { default: i18n.t("button.cancel") },
    withDeclinedEvent: { type: Boolean, default: false }
  },
  emits: ["confirmed", "declined", "close"],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const emit = __emit;

const props = __props;

const isShownModal = ref(false);

const titleValue = computed(() => {
  return props.title || i18n.t("label.confirmAction");
});

const show = () => (isShownModal.value = true);

const close = () => {
  emit("close");
  isShownModal.value = false;
};

const decline = () => {
  emit("declined");
  isShownModal.value = false;
};

const onClickActionButton = () => {
  emit("confirmed");
  close();
};

const onClickCloseButton = () => {
  props.withDeclinedEvent ? decline() : close();
};

__expose({
  close,
  show,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(VModal), {
    modelValue: isShownModal.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((isShownModal).value = $event)),
    "max-width": "md",
    title: titleValue.value,
    onClose: close
  }, {
    "footer-left": _withCtx(() => [
      _createVNode(_unref(VButton), {
        text: props.actionButtonText,
        "data-cy": "confirm-modal-action-button",
        onClick: onClickActionButton
      }, null, 8, ["text"])
    ]),
    "footer-right": _withCtx(() => [
      _createVNode(_unref(VButton), {
        text: props.closeButtonText,
        variant: "secondary",
        onClick: onClickCloseButton
      }, null, 8, ["text"])
    ]),
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default")
    ], undefined, true),
    _: 3
  }, 8, ["modelValue", "title"]))
}
}

})